export default "__VITE_ASSET__BVpIXdSH__"